import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { AttributeTypes } from 'src/global-variables';
import { Translation } from './Translation';
export interface Attribute {
  Id: number;
  RemoteId?: any;
  Name: string;
  Position?: any;
  Type: AttributeTypes;
  Scope?: Scope;
  DefaultValue?: any;
  IsRequired?: any;
  Visible?: any;
  IsConfigurable?: any;
  IsUnique?: any;
  AddToCol?: any;
  Label: any;
  Original?: any;
  ChannelId?: any;
  Object?: any;
  SapmodelPropId?: any;
  IsSystem?: any;
  PimobjectId?: any;
  ImportFlag?: any;
  AttributeGroup?: AttributesGroup;
  AttributesSets?: any[];
  ParentAttributeId?: number;
  InverseRelationTitle?: string;
  AttributeOptions: AttributeOption[];
  AttributeValidators?: AttributeValidator[];
}

export interface AttributeValidator {
  Id: number;
  AttributeId: number;
  ValidatorType: number;
  ValidatorContent: string;
  Active: boolean;
}
export interface AttributeOption {
  Id: number;
  Name: string;
  IsDefault: boolean;
  AttributeId?: number;
  Value: string;
  Translations?: Translation[];
}
export interface AttributeGroupAttribute {
  Id?: number;
  AttributeId: number;
  GroupId: number;
}
export class AttributesGroup {
  Id?: number;
  RemoteAttributeSetId?: any;
  RemoteId?: any;
  Name: string;
  Description?: any;
  Position?: any;
  ChannelId?: any;
  IsSystem?: any;
  ImportFlag?: any;
  Attributes?: Attribute[];
  AttributeSet?: AttributeSet;
  AttributeSetId?: number;
}

export interface AttributeSet {
  Id: number;
  ObjectType: number;
  Name: string;
  Description: string;
  Position?: any;
  Remoteid: any;
  Channelid: any;
  Object?: any;
  IsSystem?: any;
  ImportFlag?: any;
  Attributes: Attribute[];
  AttributeGroups: AttributesGroup[];
}

export enum Scope {
  Language = '1',
  Global = '2',
}

export interface customAttributeOption {
  id?: number;
  objectType?: number;
  name: string;
  description?: any;
  value: string;
  AttributeId?: number;
  position?: any;
  channelstoreView?: any;
  isDefault?: boolean;
  line?: any;
  channelId?: any;
  importFlag?: any;
}
export interface AttributeValue {
  Id?: number;
  AttributeId: number;
  ObjectId?: number;
  ObjectType?: number;
  LanguageId: number;
  Value?: any;
  OptionValueId?: number;
}
export interface customAttributeValue {
  id?: number;
  attributeId: number;
  objectId?: number;
  objectType?: number;
  languageId: number;
  value?: any;
  optionValueId?: number;
}
export enum AttributeValidators {
  Max = 0,
  Min,
  MaxLength,
  MinLength,
  Regex,
  MaxDate,
  MinDate,
}

export interface AttributeValidatorModel {
  code: number;
  name: string;
  type: AttributeTypes;
}
export function GetAttributeValidators(
  type: AttributeTypes
): AttributeValidatorModel[] {
  switch (type) {
    case AttributeTypes.Number:
      return [
        {
          code: AttributeValidators.Max,
          name: 'Max number',
          type: AttributeTypes.Number,
        },
        {
          code: AttributeValidators.Min,
          name: 'Min number',
          type: AttributeTypes.Number,
        },
      ];

    case AttributeTypes.Text:
    case AttributeTypes.String:
      return [
        {
          code: AttributeValidators.MaxLength,
          name: 'Max length',
          type: AttributeTypes.Number,
        },
        {
          code: AttributeValidators.MinLength,
          name: 'Min length',
          type: AttributeTypes.Number,
        },
        {
          code: AttributeValidators.Regex,
          name: 'Regex',
          type: AttributeTypes.String,
        },
      ];
    case AttributeTypes.Date:
      return [
        {
          code: AttributeValidators.MaxDate,
          name: 'Max date',
          type: AttributeTypes.Date,
        },
        {
          code: AttributeValidators.MinDate,
          name: 'Min date',
          type: AttributeTypes.Date,
        },
      ];
    default:
      return [];
  }
}

export const predefinedUOMs: { [key: string]: DropDownOption[] } = {
  Length: [
    { Code: 'meter', Label: 'meter' },
    { Code: 'centimeter', Label: 'centimeter' },
    { Code: 'kilometer', Label: 'kilometer' },
    { Code: 'inch', Label: 'inch' },
    { Code: 'foot', Label: 'foot' },
    { Code: 'yard', Label: 'yard' },
    { Code: 'mile', Label: 'mile' },
  ],
  Mass: [
    { Code: 'gram', Label: 'gram' },
    { Code: 'kilogram', Label: 'kilogram' },
    { Code: 'tonne', Label: 'tonne' },
    { Code: 'ounce', Label: 'ounce' },
    { Code: 'pound', Label: 'pound' },
  ],
  Time: [
    { Code: 'second', Label: 'second' },
    { Code: 'minute', Label: 'minute' },
    { Code: 'hour', Label: 'hour' },
    { Code: 'day', Label: 'day' },
    { Code: 'week', Label: 'week' },
    { Code: 'month', Label: 'month' },
    { Code: 'year', Label: 'year' },
  ],
  Temperature: [
    { Code: 'celsius', Label: 'celsius' },
    { Code: 'fahrenheit', Label: 'fahrenheit' },
    { Code: 'kelvin', Label: 'kelvin' },
  ],
  Volume: [
    { Code: 'cubic meter', Label: 'cubic meter' },
    { Code: 'liter', Label: 'liter' },
    { Code: 'milliliter', Label: 'milliliter' },
    { Code: 'gallon', Label: 'gallon' },
    { Code: 'quart', Label: 'quart' },
    { Code: 'pint', Label: 'pint' },
    { Code: 'fluid ounce', Label: 'fluid ounce' },
  ],
  Area: [
    { Code: 'square meter', Label: 'square meter' },
    { Code: 'square kilometer', Label: 'square kilometer' },
    { Code: 'square foot', Label: 'square foot' },
    { Code: 'square mile', Label: 'square mile' },
    { Code: 'acre', Label: 'acre' },
  ],
  Speed: [
    { Code: 'meter per second', Label: 'meter per second' },
    { Code: 'kilometer per hour', Label: 'kilometer per hour' },
    { Code: 'mile per hour', Label: 'mile per hour' },
  ],
  Pressure: [
    { Code: 'pascal', Label: 'pascal' },
    { Code: 'bar', Label: 'bar' },
    { Code: 'atmosphere', Label: 'atmosphere' },
    { Code: 'millimeter of mercury', Label: 'millimeter of mercury' },
  ],
  Energy: [
    { Code: 'joule', Label: 'joule' },
    { Code: 'calorie', Label: 'calorie' },
    { Code: 'kilocalorie', Label: 'kilocalorie' },
    { Code: 'electronvolt', Label: 'electronvolt' },
  ],
  Power: [
    { Code: 'watt', Label: 'watt' },
    { Code: 'kilowatt', Label: 'kilowatt' },
    { Code: 'horsepower', Label: 'horsepower' },
  ],
  Frequency: [
    { Code: 'hertz', Label: 'hertz' },
    { Code: 'kilohertz', Label: 'kilohertz' },
    { Code: 'megahertz', Label: 'megahertz' },
    { Code: 'gigahertz', Label: 'gigahertz' },
  ],
  'Electricity Current': [
    { Code: 'ampere', Label: 'ampere' },
    { Code: 'milliampere', Label: 'milliampere' },
  ],
  Voltage: [
    { Code: 'volt', Label: 'volt' },
    { Code: 'millivolt', Label: 'millivolt' },
  ],
  Resistance: [
    { Code: 'ohm', Label: 'ohm' },
    { Code: 'kilohm', Label: 'kilohm' },
    { Code: 'megohm', Label: 'megohm' },
  ],
  Angle: [
    { Code: 'degree', Label: 'degree' },
    { Code: 'radian', Label: 'radian' },
    { Code: 'arcminute', Label: 'arcminute' },
    { Code: 'arcsecond', Label: 'arcsecond' },
  ],
  Storage: [
    { Code: 'bit', Label: 'bit' },
    { Code: 'byte', Label: 'byte' },
    { Code: 'kilobyte', Label: 'kilobyte' },
    { Code: 'megabyte', Label: 'megabyte' },
    { Code: 'gigabyte', Label: 'gigabyte' },
    { Code: 'terabyte', Label: 'terabyte' },
  ],
  Force: [
    { Code: 'newton', Label: 'newton' },
    { Code: 'dyne', Label: 'dyne' },
    { Code: 'pound-force', Label: 'pound-force' },
  ],
};
